import { defineMessages } from "react-intl"

export const OBJECT_TYPE = "products"
export const PRODUCT_BUNDLE_ACTION_ID = {
    CREATE: "product-create" as const,
    UPDATE: "product-update" as const,
    DELETE: "product-delete" as const,
    GET: "product-get" as const
}

export const messages = defineMessages({
    "search_bundle_placeholder": {
        id: "listing.products.list.placeholder.search_product",
        defaultMessage: "Search bundles...",
    },
    "product.bundle.forms.bundle_form.title_placeholder": {
        id: "product.bundle.forms.bundle_form.title_placeholder",
        defaultMessage: "Name of the product or service bundle..."
    },
    "product.bundle.forms.bundle_form.short_description_placeholder": {
        id: "product.bundle.forms.bundle_form.short_description_placeholder",
        defaultMessage: "Short description that describes items in bundle..."
    },
    "product.bundle.forms.bundle_form.sku_placeholder": {
        id: "product.bundle.forms.bundle_form.sku_placeholder",
        defaultMessage: "SKU of the product or service"
    },
    "product.bundle.forms.bundle_form.barcode_placeholder": {
        id: "product.bundle.forms.bundle_form.barcode_placeholder",
        defaultMessage: "Barcode of the product or service"
    },
    "product.bundle.forms.bundle_form.labels_placeholder": {
        id: "product.bundle.forms.bundle_form.labels_placeholder",
        defaultMessage: "Select..."
    },
    "product.bundle.forms.bundle_form.save_btn": {
        id: "product.bundle.forms.bundle_form.save_btn",
        defaultMessage: "Save"
    },
    "product.bundle.forms.bundle_form.title_blank_error": {
        id: "product.bundle.forms.bundle_form.title_blank_error",
        defaultMessage: "The title of the bundle can not be blank"
    },
    "product.bundle.forms.bundle_form.empty_bundle_error": {
        id: "product.bundle.forms.bundle_form.empty_bundle_error",
        defaultMessage: "Uh-oh! It looks like your bundle is empty."
    },
    "product.bundle.forms.error": {
        id: "product.bundle.forms.error",
        defaultMessage: "Error!"
    }
})

export const bundleCompositionMessages = defineMessages({
    "product.bundle.forms.bundle_composition_form.modal_message": {
        id: "product.bundle.forms.bundle_composition_form.modal_message",
        defaultMessage: "*Custom attributes are not applicable to bundle items."
    }
})

export const BUNDLE_LISTING_HEADER = [
    {
        key: "product.components.product_bundle_list_header_image",
        id: "product.components.product_bundle_list_header_image",
        defaultMessage: "Image"
    },
    {
        key: "product.components.product_bundle_list_header_title",
        id: "product.components.product_bundle_list_header_title",
        defaultMessage: "Title"
    },
    {
        key: "product.components.product_bundle_list_header_labels",
        id: "product.components.product_bundle_list_header_labels",
        defaultMessage: "Labels"
    },
    {
        key: "product.components.product_bundle_list_header_inventory_label",
        id: "product.components.product_bundle_list_header_inventory_label",
        defaultMessage: "Inventory"
    },
    {
        key: "product.components.product_bundle_list_header_price",
        id: "product.components.product_bundle_list_header_price",
        defaultMessage: "Price"
    }
]

export const BUNDLE_LISTING_SEARCH_PARAMS = {
    keywords: "*",
    objects: ["products"],
    fields: ["*"],
    filters: {
        type: "bundle"
    },
    pageSize: 5,
    activePage: 1,
    sortByField: "titleSort",
    sortAsc: true
}



// WEBPACK FOOTER //
// ./src/utils/bundle/constants.ts